// extracted by mini-css-extract-plugin
export default {"dialog":"_smXdijAlF8hT6N7","body":"rn4RYp144LUmoTDw","header":"ej8e7nRemVQ01qW7","title":"WrhAe1TmIagWDl98","subTitle":"QPpKTiGp9jopWYYR"};